import React, { useState, useEffect } from 'react';
import './Indicateurs.css';

function Onglets({ indicateurInfo }) {
  const [activeTab, setActiveTab] = useState('rang');
  
  // Initialiser la classe sur le body au chargement du composant
  useEffect(() => {
    // Nettoyer lors du démontage du composant
    return () => {
      document.body.classList.remove('menu-hidden-mode');
    };
  }, []);

  // Définir les onglets
  const tabs = [
    { id: 'producteur', label: 'Producteur de l\'indicateur' },
    { id: 'definition', label: 'Définitions de l\'indicateur' },
    { id: 'methode', label: 'Methodes de calcul' },
    { id: 'donnees', label: 'Donnees en entrees' },
    { id: 'sources', label: 'Sources de données' },
    { id: 'interpretation', label: 'Interpretation' },
    { id: 'rang', label: 'Rang' }
  ];

  // Définir le contenu en fonction de l'onglet actif
  const getTabContent = (tabId) => {
    switch (tabId) {
      case 'producteur':
        return indicateurInfo?.producteur || 'Informations sur le producteur de l\'indicateur';
      case 'definition':
        return indicateurInfo?.definition || 'Le PIB par habitant mesure le niveau de richesse par personne.';
      case 'methode':
        return (
          <div>
            <h3 className="content-title">Méthode de calcul</h3>
            <p>PIB total / Population totale</p>
          </div>
        );
      case 'donnees':
        return indicateurInfo?.donnees_entrees || 'Description des données utilisées en entrée';
      case 'sources':
        return indicateurInfo?.sources_donnees || 'Sources des données utilisées pour l\'indicateur';
      case 'interpretation':
        return indicateurInfo?.interpretation || 'Guide d\'interprétation des résultats';
      case 'rang':
        return renderRangTable();
      default:
        return 'Contenu non disponible';
    }
  };

  // Fonction pour obtenir la couleur de fond du drapeau
  const getFlagColors = (pays) => {
    // Retourne les classes CSS pour chaque drapeau
    const flagClasses = {
      'Côte d\'Ivoire': 'ci-flag-colors',
      'France': 'fr-flag-colors',
      'États-Unis': 'us-flag-colors',
      'Allemagne': 'de-flag-colors',
      'Royaume-Uni': 'gb-flag-colors',
      'Italie': 'it-flag-colors',
      'Japon': 'jp-flag-colors',
      'Chine': 'cn-flag-colors',
      'Brésil': 'br-flag-colors',
      'Canada': 'ca-flag-colors'
    };
    
    return flagClasses[pays] || 'default-flag';
  };

  // Fonction pour rendre le drapeau avec des éléments supplémentaires si nécessaire
  const renderFlag = (pays) => {
    const flagClass = getFlagColors(pays);
    
    if (pays === 'États-Unis') {
      return (
        <div className={`flag-box ${flagClass}`}>
          <span>★ ★ ★</span>
        </div>
      );
    }
    
    return <div className={`flag-box ${flagClass}`}></div>;
  };

  // Fonction pour rendre un tableau pour l'onglet Rang
  const renderRangTable = () => {
    // Données de classement 
    const rangData = [
      { pays: 'Côte d\'Ivoire', valeur: 15000, rang: 1 },
      { pays: 'France', valeur: 12345, rang: 2 },
      { pays: 'États-Unis', valeur: 9876, rang: 3 },
      { pays: 'Allemagne', valeur: 8765, rang: 4 },
      { pays: 'Royaume-Uni', valeur: 7654, rang: 5 },
      { pays: 'Italie', valeur: 6543, rang: 6 }
    ];

    return (
      <div className="pays-table-container">
        <table className="pays-table">
          <thead>
            <tr>
              <th>Pays</th>
              <th>Valeur</th>
              <th>Rang</th>
            </tr>
          </thead>
          <tbody>
            {rangData.map((item, index) => (
              <tr key={index} className={item.pays === 'France' ? 'highlight-row' : ''}>
                <td className="pays-cell">
                  {renderFlag(item.pays)}
                  <span>{item.pays}</span>
                </td>
                <td>{item.valeur}</td>
                <td>{item.rang}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  };

  return (
    <div className="tabs-container indicator-section">
      <div className="tabs-menu">
        {tabs.map(tab => (
          <div 
            key={tab.id}
            className={`tab-item ${activeTab === tab.id ? 'active' : ''}`}
            onClick={() => setActiveTab(tab.id)}
          >
            {tab.label}
          </div>
        ))}
      </div>
      
      <div className="tab-content">
        {getTabContent(activeTab)}
      </div>
    </div>
  );
}

export default Onglets; 